
'use strict'

import Validate from './Validate';

class Empty extends Validate {
    
    constructor(){
        super();
        this.error = '{name} no puede estar vacío';
    }

    validate (value) {
        let val = value.trim();
        return val == '' ? false : true;
    }
}

export default Empty;
